import React from "react";

function ShutdownBanner() {
  const styles = {
    banner: {
      position: "relative",
      height: 60,
      width: "100%",
      background: "#121212",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    icon: {
      width: 20,
      height: 20,
      fill: "white",
    },
  };

  const icon = (
    <svg style={styles.icon} focusable="false" viewBox="0 0 24 24">
      <path d="M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z" />
    </svg>
  );

  return (
    <div style={styles.banner}>
      {icon}
      &nbsp;
      <b>Important Notice:</b>
      &nbsp;
      <p style={{ color: "#fff" }}>
        Dojo 2.0 updates are now Live and Fully Operational!
        <br />
        Need Help? Looking to Grow? Contact us&nbsp;
        <a href="mailto:hello@dojomojo.com" rel="noopener noreferrer">
          hello@dojomojo.com
        </a>
      </p>
    </div>
  );
}

export default ShutdownBanner;
